import { useState } from "react";
import { get, find } from "lodash";
import useApi from "hooks/useApi";
const CheckDuplicate = (props) => {
  const [exist, setExist] = useState(false);
  const [loading, setLoading] = useState(false);
  const api = useApi();
  const { apiPath, value, match, unMatch } = props;
  async function check() {
    const val = encodeURIComponent(value.trim());

    if (val) {
      setLoading(true);
      const result = await api.get(`${apiPath}/${val}`);
      if (apiPath === "org/get_org") {
        if (result.status === 404) {
          setExist(false);
        } else {
          setExist(true);
        }
      } else if (match || unMatch) {
        const data = get(result, "data.data", []);
        const found = find(
          data,
          (obj) =>
            obj[match.key] === match.value &&
            obj[unMatch.key] !== unMatch.value,
          false
        );
        if (found) {
          setExist(true);
        } else {
          setExist(false);
        }
      } else {
        if (result?.data.toString() === "true") {
          setExist(true);
        } else {
          setExist(false);
        }
      }
      setLoading(false);
    }
  }
  return props.children({ loading, check, exist });
};

export { CheckDuplicate };
